export const updateWorkExperienceFormFields = {
  jobTitle: '',
  employmentType: '',
  companyName: '',
  logo: '',
  start: '',
  end: '',
  currentlyWorking: false,
  description: ''
};

export const updateWorkExperienceErrors = {
  jobTitle: '',
  employmentType: '',
  companyName: '',
  start: '',
  logo: '',
  end: '',
  currentlyWorking: '',
  description: ''
};
